var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConnectivityProblem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.86 16.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.55,
    y1: 2.75,
    x2: 16.94,
    y2: 15.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.42,2.15s1.14-1.15,3.04-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.62,13.47H3.87s-2.87.16-2.87-2.99c0-2.83,3.14-3.16,3.14-3.16,0,0-.18-1.31.42-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.18,11.9s.68-.74.68-2.17c0-2.83-3.14-3.16-3.14-3.16,0,0,.6-5.57-5.26-5.57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnectivityProblem);
export default __webpack_public_path__ + "static/media/icon_connectivity_problem.3722345d2350b603f8bb0a0c520a0b20.svg";
export { ForwardRef as ReactComponent };